import '../css/program-finder.scss'

import React, { Component } from 'react'
import { render } from 'react-dom'

import { Api } from './Api'

import { FilterBar } from './components/FilterBar'
import { Programs } from './components/Programs'

class ProgramFinder extends Component {

	constructor( props ) {
		super( props )

		let initialFilters = this.getInitialFilters();

		this.state = {
			'filters': initialFilters,
			'programs': null,
			'taxonomies' : null,
			'isSearchingPrograms': true,
		}

		this.api = new Api( props.apiEndpoints )
	}

	componentDidMount() {
		this.getPrograms( this.state.filters )
		this.getTaxonomyOptions()
	}

	updateFilter( filter, value ) {
		let filters = this.state.filters
		filters[ filter ] = value

		// On pagination update, scroll to top
		let scrollTop = false
		if ( 'paged' === filter ) {
			scrollTop = true
		} else {
			filters.paged = '1'
		}

		this.setState({ filters: filters })
		this.getPrograms( filters, scrollTop )
		this.pushFiltersToURL( filters )
	}

	pushFiltersToURL( filters ) {
		let urlString = '?';

		for ( var key in filters ) {
			let val = filters[ key ];

			if ( 'object' === typeof val ) {
				for ( var subkey in val ) {
					let subval = val[ subkey ].join(',');

					urlString += `${key}[${subkey}]=${subval}&`;
				}
			} else {
				urlString += `${key}=${val}&`;
			}

		}

		urlString = urlString.slice(0, -1)

		window.history.pushState( '', '', urlString );
	}

	scrollToTop() {
		document.getElementById('program-finder-app').scrollIntoView();
	}

	getPrograms( filters, scrollTop = false ) {
		this.setState({ isSearchingPrograms: true })

		if ( scrollTop ) {
			this.scrollToTop()
		}

		this.api.getPrograms( filters )
			.then( data => {
				this.setState({ 
					programs: data,
					isSearchingPrograms: false,
				})
			})
	}

	getTaxonomyOptions() {
		this.api.getTaxonomyOptions()
			.then( data => {
				this.setState({ taxonomies: data })
			})
	}

	getDefaultFilters() {
		return {
			'q': '',
			'tax': {},
			'sort_by': '',
			'paged': 1
		}
	}

	getInitialFilters() {
		let filters = this.getDefaultFilters();

		let search = location.search.substring(1)
		let searchParams =  new URLSearchParams( search )
		for ( let param of searchParams ) {
			let key = param[0]
			let val = param[1].split(',')

			if ( key.includes('[') && key.includes(']') ) {
				// Example: [ 'tax[category]', 'tax', 'category' ];
				let matches = key.match( /^([^\[]+)\[([^\]]+)\]$/i );
				
				if ( matches.length === 3 ) {
					filters[ matches[1] ][ matches[2] ] = val
				}
			} else {
				if ( val.length === 1 ) {
					val = val[0]
				}

				filters[ key ] = val
			}
		}

		return filters;
	}

	resetFilters() {
		let defaultFilters = this.getDefaultFilters()

		if ( defaultFilters === this.state.filters ) {
			return
		}

		this.setState({ filters: defaultFilters })
		this.getPrograms( defaultFilters )

		// Uncheck taxonomy checkboxes
		Array.from( document.getElementsByClassName('pf-taxonomy__input') ).forEach( checkbox => {
			checkbox.checked = 0
		})
	}

	render() {
		if ( null === this.state.programs || null === this.state.taxonomies ) {
			return (
				<div className="pf-program-finder">
					<div className="pf-program-finder__loader">
						<div className="pf-program-finder__loader-inner">Loading...</div>
					</div>
				</div>
			)
		} else {
			return (
				<div className="pf-program-finder">

					<FilterBar 
						resetFilters={ this.resetFilters.bind( this ) }
						taxonomies={ this.state.taxonomies }
						filters={ this.state.filters } 
						programsCount={ this.state.programs.found_posts }
						updateFilter={ this.updateFilter.bind( this ) } 
					/>
 
					<Programs 
						isSearchingPrograms={ this.state.isSearchingPrograms }
						programsCount={ this.state.programs.found_posts }
						filters={ this.state.filters } 
						programs={ this.state.programs } 
						placeholderImage={ this.props.pageData.placeholderImage }
						updateFilter={ this.updateFilter.bind( this ) } 
					/>
				</div>
			)
		}
	}

}

if ( 'undefined' !== typeof pfApiEndpoints && 'undefined' !== typeof pfPageData ) {
	(function( pfApiEndpoints, pfPageData ) {
		window.React = React

		render(
			<ProgramFinder apiEndpoints={ pfApiEndpoints } pageData={ pfPageData } />,
			document.getElementById('program-finder-app')
		)
	})( pfApiEndpoints, pfPageData )
}